<template>
    <ul class="tab">
        <li v-for="(value, key) in departureAreaItemList" :value="key" @click="onSelectArea(key)" :class="{ current: selectedArea == key }" >
            {{ value.name }}発
        </li>
    </ul>
</template>

<script>
    import { ref } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            dept_area_list : {type: Object, require: true},
            selected_area : {type: String, require: true},
        },
        emits: ['selectedArea'],
        setup (props, context) {
            // メソッド実装 押されたとき
            const onSelectArea = (areaValue) => {
                selectedArea.value = areaValue
                context.emit("selectedArea", areaValue);
            }

            // セットアップ。初期実行
            const departureAreaItemList = props.dept_area_list
            const selectedArea = ref(props.selected_area)

            return {
                departureAreaItemList,
                onSelectArea,
                selectedArea,
            }
        },
    })
</script>